import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './lib/vue-axios'
import store from './store'
import i18n from './translations'
import vuetify from './plugins/vuetify'
import '@fortawesome/fontawesome-free/css/all.css'
import VueDayjs from 'vue-dayjs-plugin'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  let mainTitle = 'Panel klienta'

  if (location.host.includes('.ro')) {
    mainTitle = 'Panoul clientului'
  } else if (location.host.includes('.bg')) {
    mainTitle = 'Клиентски панел'
  }

  if (to.fullPath === '/') {
    if (location.host.includes('.ro')) {
      window.document.title = mainTitle + ' | ' + to.meta.title.ro
    } else if (location.host.includes('.bg')) {
      window.document.title = mainTitle + ' | ' + to.meta.title.bg
    } else if (location.host.includes('.euro-tax.pl')) {
      window.document.title = mainTitle + ' | Euro-tax.com'
    } else {
      window.document.title = mainTitle + ' | CUF'
    }
  } else {
    if (to.meta && to.meta.title) {
      if (location.host.includes('.ro')) {
        window.document.title = mainTitle + ' | ' + to.meta.title.ro
      } else if (location.host.includes('.bg')) {
        window.document.title = mainTitle + ' | ' + to.meta.title.bg
      } else {
        window.document.title = mainTitle + ' | ' + to.meta.title.pl
      }
    } else {
      window.document.title = mainTitle
    }
  }

  if (to.fullPath.includes('?login=') || (to.fullPath.includes('?type='))) {
    next()
  } else if (to.fullPath !== '/' && to.fullPath !== '/remind_password' && !to.fullPath.includes('/verify/') && store.state.auth.client == null) {
    next({ path: '/' })
  } else if (to.fullPath !== '/active_account' && !to.fullPath.includes('/verify/') && store.state.auth.client !== null && !store.state.auth.client.registered) {
    next({ path: '/active_account' })
  } else if (to.fullPath !== '/reset_password' && to.fullPath !== '/active_account' && !to.fullPath.includes('/verify/') && store.state.auth.client !== null && store.state.auth.client.reset_password) {
    next({ path: '/reset_password' })
  } else {
    next()
  }
})

Vue.use(VueDayjs)

Vue.axios.interceptors.response.use((response) => { // intercept the global error
  store.dispatch('toggleLoading', false)
  return response
}, function (error) {
  if ((error.response.status === 400 || error.response.status === 401 || error.response.status === 403) && !error.request.responseURL.includes('/auth/')) {
    store.dispatch('toggleLoading', false)
    delete localStorage.token
    store.dispatch('logout')
    router.push('/')
  } else if (error.response.status === 404) {
    store.dispatch('toggleLoading', false)
    router.push('/not_found')
  } else {
    return Promise.reject(error)
  }
})

new Vue({
  router,
  axios,
  store,
  i18n,
  vuetify,
  created () {
    const html = document.documentElement // returns the html tag
    let lang = 'pl'

    if (location.host.includes('.ro')) {
      lang = 'ro'
    } else if (location.host.includes('.bg')) {
      lang = 'bg'
    }

    html.setAttribute('lang', lang)
  },
  render: h => h(App)
}).$mount('#app')
